import React from 'react';
import SvgLoading from './../SvgLoading';
import { Button as RegularButton } from './style';

export const Button = ({
    title,
    onClick = () => {},
    disabled,
    isLoading = false,
    style,
    loadingProps = {
        color: 'white',
        height: 25
    },
    ...props
}) => {
    return (
        <RegularButton
            style={style}
            onClick={() => {
                if (isLoading) return;
                onClick();
            }}
            disabled={disabled}
            {...props}
        >
            {isLoading ? <SvgLoading {...loadingProps} /> : title}
        </RegularButton>
    );
};
